import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../../app/AuthorizationProvider';
import { Adjustment } from '../../../graphql/components';

interface AdjustmentTileContentProps {
  adjustment: Adjustment;
  timezone: string;
}

export const AdjustmentTileContent: React.FC<AdjustmentTileContentProps> = ({
  adjustment: {
    averageHandlingTime,
    contactVolume,
    dateTimeRange: { endDateTime, startDateTime },
    shrinkagePercentage: shrinkage,
    concurrentChatsCount,
  },
  timezone,
}) => {
  const { t } = useTranslation();
  const { locale, localeObj } = useAuth();
  const startDateTimeConverted = utcToZonedTime(startDateTime, timezone);
  const endDateTimeConverted = utcToZonedTime(endDateTime, timezone);
  const contactVolumePercentage = contactVolume / 100;
  const averageHandlingTimePercentage = averageHandlingTime / 100;
  const shrinkagePercentage = shrinkage / 100;

  return (
    <>
      <dl data-test-id="adjustment:startDateTime">
        <dt>{t('date.from')}:</dt>{' '}
        <dd>{format(startDateTimeConverted, t('date.formats.full'), { locale: localeObj })}</dd>
      </dl>
      <dl data-test-id="adjustment:endDateTime">
        <dt>{t('date.to')}:</dt> <dd>{format(endDateTimeConverted, t('date.formats.full'), { locale: localeObj })}</dd>
      </dl>
      <dl data-test-id="adjustment:contactVolume">
        <dt>{t('forecast.forecastedContactVolume')}:</dt>
        <dd>{contactVolumePercentage.toLocaleString(locale, { maximumFractionDigits: 2, style: 'percent' })}</dd>
      </dl>
      <dl data-test-id="adjustment:averageHandlingTime">
        <dt>{t('forecast.forecastedAHT')}:</dt>
        <dd>{averageHandlingTimePercentage.toLocaleString(locale, { maximumFractionDigits: 2, style: 'percent' })}</dd>
      </dl>
      <dl data-test-id="adjustment:shrinkage">
        <dt>{t('forecast.shrinkage')}:</dt>
        <dd>{shrinkagePercentage.toLocaleString(locale, { maximumFractionDigits: 2, style: 'percent' })}</dd>
      </dl>
      {concurrentChatsCount && (
        <dl data-test-id="adjustment:concurrentChats">
          <dt>{t('forecast.concurrentChats')}:</dt>
          <dd>{concurrentChatsCount}</dd>
        </dl>
      )}
    </>
  );
};
